<template>
  <div
    v-if="visible"
    class="over-limit mt-200"
  >
    {{ $t('general.bulk.overLimit', { limit }) }}
  </div>
</template>

<script setup lang="ts">
type TProps = {
  visible: boolean;
  limit: number;
};

defineProps<TProps>();
</script>

<style lang="scss" scoped>
  .over-limit {
    color: $basecolor-error;
    font-size: $fontsize-100;
  }
</style>
